import React, { useState } from "react";
import PollLists from "components/TeamPoll/PollLists/PollLists.js";
import { PollContext } from "store/contexts/pollContext";
import { useTeamContext } from "store/contexts/teamContext";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "components/Loader";
import Button from "components/CustomButton";
// import EditAddPoll from "components/TeamPoll/EditAddPoll/EditAddPoll.js";
import EditAddPoll from "components/PollComponent/EditAddPoll/EditAddPoll.js";
import FabButton from "components/FabButton";
import * as timelineActions from "reteamStore/actions";
import { useSelector, useDispatch } from "react-redux";
import { useTeamActionContext } from "store/contexts/teamActionContext";

export default () => {
  const { team } = useTeamContext();
  const dispatch = useDispatch();
  const { isLoading, total, page, pollQuestion } = useSelector(
    (state) => state.pollListReducer
  );
  const { allTimelinePollList, createNewPost } = useTeamActionContext();
  const [dialogState, setDialogState] = useState(false);
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const createNewPoll = (poll) => {
    if (!poll) {
      return;
    }

    dispatch(timelineActions.createPoll(poll));
  };

  const updatePoll = (poll) => {
    dispatch(timelineActions.updatePoll(poll));
  };

  const getNextPageData = () => {
    allTimelinePollList(page + 1);
    dispatch(timelineActions.pollPageIncreament());
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <div className="poll-load-more">
          <Button buttonClass="grad_btn w-50 h-50" onClick={getNextPageData}>
            Load More
          </Button>
        </div>
      )}
    </>
  );

  return (
    <PollContext.Provider
      value={{
        createNewPoll,
        updatePoll,
      }}
    >
      <FabButton
        buttonClass="fab-button add"
        onClick={() => setDialogState(true)}
      >
        +
      </FabButton>
      {dialogState && (
        <EditAddPoll
          createNewPost={createNewPost}
          team={team}
          createNewPoll={createNewPoll}
          modelOpen={dialogState}
          closeModal={() => setDialogState(false)}
          id={pollQuestion.length}
          singleTeam={true}
        />
      )}

      <InfiniteScroll
        style={{ overflow: "hidden" }}
        dataLength={total ?? 0}
        next={getNextPageData}
        hasMore={pollQuestion.length !== total}
        loader={LoadingContainer}
        scrollableTarget="main-panel-right"
        endMessage={
          <div style={{ textAlign: "center" }}>
            {total > 0 && <div>Yay! You have seen it all</div>}
          </div>
        }
      >
        <PollLists total={total} pollQuestion={pollQuestion} />
      </InfiniteScroll>
    </PollContext.Provider>
  );
};
